<template>
  <div class="d-inline-block">

    <!-- Button trigger modal -->
    <button :id="itemid" v-on:click="modal.show(); showModal();" type="button" class="btn m-1" :class="attributes.sn.toLowerCase() === sn ? 'btn-warning' : 'btn-outline-success'" data-bs-toggle="modal" :data-bs-target="'#modal' + itemid">
      {{ attributes.displayname }}
    </button>

    <!-- Modal -->
    <div class="modal fade" :id="'#modal' + itemid" ref="myModal" tabindex="-1" :aria-labelledby="'#modal-label' + itemid" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" :id="'#modal-label' + itemid">
              {{ attributes.displayname }}
            </h1>
            <button type="button" v-on:click="modal.hide()" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12 col-md-3">
                <span v-if="attributes.ipbtrombilisterouge === 'TRUE'">
					<svg xmlns="http://www.w3.org/2000/svg" width="160" height="160" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16">
						<path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>
					</svg>
                </span>
                <span v-else>
                  <img class="img-fluid" :src="userImage" :alt="'Photo de ' + attributes.displayname" />
                </span>
              </div>
              <div class="col-12 col-md-9">
                <ul>
                  <li>
                    <b>Nom complet</b> : {{ attributes.displayname }}
                  </li>
                  <li>
                    <b>Mail</b> : <a :href="'mailto:' + attributes.mail" title="Envoyer un message">{{ attributes.mail }}</a>
                  </li>
                   <li v-if="!attributes.ipbcoordonnees">
                    <b>Affectation</b> : {{ attributes.supannentiteaffectation }}
                  </li>
                  <li v-if="attributes.telephonenumber">
                    <b>Téléphone</b> : {{ attributes.telephonenumber }} (principal)
                  </li>
                </ul>
              </div>
            </div>
            <div class="table-responsive">
              <table v-if="attributes.ipbcoordonnees" class="table table-striped">
                <thead>
                <tr>
                  <th>Affectation</th>
                  <th>Fonction(s)</th>
                  <th>Bâtiment</th>
                  <th>Bureau</th>
                  <th>Téléphone</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(affect, index) in cleanInfos(attributes.ipbcoordonnees)" :key="index">
                  <td>
                    {{ affect.affectation }}
                  </td>
                  <td>
                    {{ affect.fonction }}
                  </td>
                  <td>
                    {{ affect.batiment }}
                  </td>
                  <td>
                    {{ affect.bureau }}
                  </td>
                  <td>
                    {{ affect.telephone }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" v-on:click="modal.hide()" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { Modal } from 'bootstrap'

import axios from 'axios'

export default {
  name: 'Pers-Card',
  props: {
    itemid: {
      type: Number,
      default: null
    },
    sn: {
      type: String,
      default: ''
    },
    attributes: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      userImage: null,
      modal: null
    }
  },
  mounted () {
    // Initialize the modal
    this.modal = new Modal(this.$refs.myModal)
  },
  methods: {
    cleanInfos (str) {
      let result = []
      let refTab = null
      if (Array.isArray(str)) {
        refTab = str
      } else {
        refTab = str.split('&&test&&')
      }
      for (var z=0; z<refTab.length; z++) {
        let cleanStr = refTab[z].split('[fonctionvalide')[0].replaceAll("][", '#').replaceAll("[", '').replaceAll("]", '')
        cleanStr = cleanStr.replace("detail=","- ") // On garde 'détail' (EM)
        let cleanTab = cleanStr.split('#')
        let obj = {}
        for (var i=0; i<cleanTab.length; i++) {
          let attrTab = cleanTab[i].split('=')
          obj[attrTab[0]] = attrTab[1]
        }
        result.push(obj)
      }
      return result
    },
    checkTest () {
      this.loading = true
      // Recheche des données dans AGRHUM (EM)
      axios
          .get('https://ccc.bordeaux-inp.fr/annuaire/server.pl', {
            params: {
              fqdn: 'ccc.bordeaux-inp.fr',
              operation: 'test',
              _proxy_methode: 'test',
            },
            responseType: 'text',
            crossDomain: true,
            withCredentials: true
          })
          .then((response) => {
            this.reset()
            //console.log(response)
            if (response.res === "echec") {
              this.error = true
              throw new Error('Erreur')
            }
            if (response.status === 200) {
              //console.log(response)
              this.success = true
              this.userPhoto()
            }
          })
          .catch((error) => {
            this.error = true
            console.log('Echec récupération photo')
            console.log(error)
          })
          .finally(() => {
            this.loading =  false
          })
    },
    userPhoto () {
      // Recheche des données dans AGRHUM (EM)
      axios
          .get('https://ccc.bordeaux-inp.fr/annuaire/server.pl', {
            params: {
              fqdn: 'ccc.bordeaux-inp.fr',
              operation: 'afficher_utilisateur_new',
              no_individu: this.attributes.supannempid,
              _proxy_methode: 'afficher_utilisateur_new',
            },
            responseType: 'text',
            crossDomain: true,
            withCredentials: true
          })
          .then((response) => {
            //  console.log(response)
            this.userImage = response.data
          })
    },
    reset () {
      this.success = false
      this.error = false
    },
    showModal () {
      // First check the connection to bbb
      if (this.attributes.ipbtrombilisterouge === 'FALSE') {
        this.checkTest()
      }
    },
  }
}
</script>

<style>

@import url('https://fonts.googleapis.com/css2?family=Roboto+Condensed&display=swap');

html, body {
  font-family: 'Roboto', sans-serif;
}

* {
  font-family: 'Roboto', sans-serif;
}

.btn-warning, .btn-outline-success:hover {
  color: #fff !important;
  background-color: #007970 !important;
  border-color: #007970 !important;
}
.btn-warning:hover, .btn-outline-success  {
  color: #007970 !important;
  background-color: #fff !important;
  border-color: #007970 !important;
}

</style>